import script from "./AnnouncementBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementBanner.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementBanner.vue?vue&type=style&index=0&id=3b0e137c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0e137c"]])

export default __exports__